import {EntryOrderStatus} from "platform/protocol/trading/EntryOrderStatus";

export const ClosedPositionsBySymbolThreshold: number = 5;
export const ClosedPositionsThreshold: number = 500;
export const OrdersHistoryThreshold: number = 500;
export const EntryOrderFilterGroups: EntryOrderStatus[][] = [
    [EntryOrderStatus.Executed],
    [EntryOrderStatus.Cancelled, EntryOrderStatus.Rejected]
];
